<template>
  <div>
    <div class="card" style="margin-left:15px;">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 text-left">
            <button class="btn btn-outline-dark btn-sm" @click="openModal">
              <i class="fa fa-plus"></i>
              Agregar Categoria
            </button>                      
          </div>
          <div class="col-sm-6 text-right">
            <b>Total: {{ categories.length }}</b>
          </div>
        </div>

        <!-- Lista -->
        <div class="row">
          <div class="col-sm-12" style="overflow-y:auto;max-height:55vh;">
            <table class="table" id="list">
              <thead class="thead-light">
                <tr>
                  <th>Nombre</th>
                  <th class="text-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="category in categories" :key="category.id">
                  <td>
                    <b>{{ category.name }}</b> 
                  </td>
                  <td class="text-center">
                    <a title="Eliminar" @click="edit(category)" href="#" class="text-dark">
                      <i class="fa fa-edit fa-2x"></i>
                    </a>&nbsp;
                    <!-- <a title="Eliminar" @click="deleteCategory(category)" href="#" class="text-danger">
                      <i class="fa fa-trash fa-2x"></i>
                    </a> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="loading" class="text-center">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <div
      class="modal fade"
      id="category-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true">
      <div class="modal-dialog modal-sm" role="document" style="max-width:400px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="no-margin-top" style="margin-top:0;">
              {{ editing ? 'Editar' : 'Agregar' }} categoria
            </h4>                    
          </div>
          <div class="modal-body">

              <div class="form-group">
                <label>Nombre</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="name"
                />
              </div>

          </div>
          <div class="modal-footer">
            <div class="row w100">
              <div class="col-sm-3 text-left">
                <!-- Loader -->
                <div v-show="loading">
                  <div class="text-center" colspan="5">
                    <Loader />
                  </div>
                </div>
                
                <b v-show="!loading">
                  <a style="margin-top:10px;"
                  @click="closeModal"
                  :disabled="loading">
                    Cancelar
                  </a>
                </b>
              </div>
              <div class="col-sm-9 text-right">
                <button
                  style="margin-top:0 !important;"
                :disabled="loading"
                @click="saveCategory"
                class="btn main-blue-bg"
                >
                  <i class="fa fa-save"></i>&nbsp;
                  Guardar cambios                
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { CompanyService } from '../../services/CompanyService';
import Loader from './Loader'

export default {
  name: "Categories",
  props: ["company"],
  components: {Loader},
  data: function () {
    return {
      categories: [],
      loading: false,
      id: '',
      name: '',
      editing: false,
      companyService: new CompanyService()
    };
  },
  methods: {
    async saveCategory(){
      if(this.name == ''){
        this.$helpers.toast('El nombre es requerido', 'warning');
        return;
      }
      this.loading = true;
      const res = await this.companyService.saveCategory(this.company, this.name, this.id);
      if(res.ok){
        console.log(res);
        if(this.editing){
          this.categories.splice(
            this.categories.findIndex(x => x.id === this.id),
            1
          );
        }
        this.categories.push( res.category );
        this.categories = this.categories.sort(this.$helpers.sortArrayAsc);
        this.$helpers.toast('Categoria creada!', 'success');
        this.closeModal();
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
    openModal(){
      $("#category-modal").modal({
        keyboard: false,
        backdrop: false
      });
    }, 
    edit: function(category){
      this.editing = true;
      this.id = category.id;
      this.name= category.name;   
      $('#category-modal').modal(this.modalOptions);
    },
    closeModal: function(){
      this.editing = false;
      this.id = '';
      this.name = '';
      $('#category-modal').modal('hide');
    },
    deleteCategory: function(category){
      this.$helpers.confirm('La categoria se eliminara')
      .then((ok) => {
        if (ok) {
          //TODO
        } 
      });
    },
  },
  async mounted(){
    this.loading = true;
    this.categories = await this.companyService.getProductCategories(this.company);
    this.loading = false;
  }
}
</script>

<style scoped>

</style>